import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--left",
  "use": "icon-arrow--left-usage",
  "viewBox": "0 0 7 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 12\" id=\"icon-arrow--left\"><path d=\"M1.596 7.059a.988.988 0 0 1-1.322 0A.834.834 0 0 1 0 6.445c0-.222.091-.444.274-.613l4.988-4.625c.881-.817 2.204.409 1.322 1.227L1.596 7.059V5.832l4.988 4.625a.823.823 0 0 1 0 1.226.988.988 0 0 1-1.322 0L.274 7.06A.834.834 0 0 1 0 6.445c0-.222.091-.444.274-.613l4.988-4.625 1.322 1.227-4.988 4.625Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol